import { SentryErrorComponent } from '@components/Fallback'
import { EnginesTable } from '@features/staffMember/components/engines/EnginesTable'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { listEnginesRequestSchema } from '@customTypes/cloudmix/engine'
import { withListHydration } from '@lib/listState/withListHydration'

const StaffEnginesRoute = () => <EnginesTable />

const routerSchema = listEnginesRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/staff/engines')({
  component: StaffEnginesRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {},
    getTitle: () => 'Engines',
  }),
  errorComponent: SentryErrorComponent,
})
